import { render, staticRenderFns } from "./shareImg.vue?vue&type=template&id=21e4079a&"
import script from "./shareImg.vue?vue&type=script&lang=js&"
export * from "./shareImg.vue?vue&type=script&lang=js&"
import style0 from "./shareImg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports